// Note: this js is shared between GS, cr4, and engnews360

export const createSimpleModal = (modalId) => {
	const modal = $(modalId);
	modal.hide();

	if (!modal.hasClass("modal")) {
		modal.addClass("modal");

		// move div outside
		modal.prependTo(document.body);
	}

	let overlay = $("#overlay");

	// create overlay
	if (overlay.length === 0) {
		overlay = $("<div id=\"overlay\"></div>");
		overlay.hide();
		overlay.css({
			display: "none",
			position: "fixed",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			background: "#000",
			opacity: 0.5,
			filter: "alpha(opacity=50)",
			zIndex: 10010,
		});

		overlay.click(hideSimpleModal);
		overlay.prependTo(document.body);
	}
}


let simpleModalToRemoveOnClose = null;
let okToCloseModal = true;
export const showSimpleModal = (modalId, removeOnClose) => {
	if (removeOnClose) {
		simpleModalToRemoveOnClose = modalId;
	}


	const modal = $(modalId);

	if (!modal.hasClass("modal")) {
		// ensure modal was created
		createSimpleModal(modalId);
	}

	const top = Math.max($(window).height() - modal.outerHeight(), 0) / 2;
	const left = Math.max($(window).width() - modal.outerWidth(), 0) / 2;

	modal.css({
		top: top + $(window).scrollTop(),
		left: left + $(window).scrollLeft(),
		position: "absolute",
		zIndex: 10020,
	});

	// Force the modal to be up at least half a second
	okToCloseModal = false;
	setTimeout(function() {
		okToCloseModal=true;
	}, 500);

	$("#overlay").show();
	modal.show();
}


export const hideSimpleModal = () => {
	if (okToCloseModal) {
		$("#overlay").hide();
		$(".modal").hide();

		if (simpleModalToRemoveOnClose) {
			$(simpleModalToRemoveOnClose).remove();
			simpleModalToRemoveOnClose = null;
		}
	}
}
